import defaultConfig from './default'
import developmentSettings from './development'
import productionSettings from './production'
import stagingSettings from './staging'

const env = process.env.APP_ENV

function chooseConfig() {
  if (env === 'production') {
    return productionSettings
  }

  if (env === 'staging') {
    return stagingSettings
  }

  return developmentSettings
}

const config: typeof defaultConfig = chooseConfig()

export default config
